// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1dvfk","topBottomGutter":"Layout_topBottomGutter__1I9Pj"};